import {
  PayPalPaymentData,
  PayPalPaymentPayer,
  PayPalPaymentTransaction,
  PayPalPaymentRedirectUrls,
  PayPalPaymentTotals,
  PayPalPaymentAddressContainer,
} from '../../services/PayPalService';
/* eslint-disable */
// TODO: Fix camelcase
class PayPalPaymentRequest implements PayPalPaymentData {
  public intent: string;

  public payer: PayPalPaymentPayer;

  public transactions: PayPalPaymentTransaction;

  public redirect_urls: PayPalPaymentRedirectUrls;

  public id: string | undefined = undefined;

  public state: string | undefined = undefined;

  public token: string | undefined = undefined;

  constructor(
    totals: PayPalPaymentTotals,
    isDelayedCapture: boolean | null,
    defaultCurrency: string | null,
    addressContainer?: PayPalPaymentAddressContainer
  ) {
    const { total, subtotal, shipping, tax } = totals;
    this.intent = isDelayedCapture ? 'AUTHORIZE' : 'SALE';
    this.payer = {
      payment_method: 'paypal',
    };
    this.transactions = {
      Amount: {
        currencyValue: defaultCurrency ?? 'USD',
        total,
        details: {
          tax,
          shipping,
          subtotal,
        },
      },
    };
    this.redirect_urls = {
      return_url: 'https://www.paypal.com/checkoutnow/error',
      cancel_url: 'https://www.paypal.com/checkoutnow/error',
    };
    if (addressContainer) {
      this.transactions.item_list = addressContainer;
    }
  }
}

export default PayPalPaymentRequest;
